!function () {
  const selector = '[data-availability-badge]';

  function getVariantData(el) {
    return theme.helpers.safelyParseJson(el.dataset.variantData) || {};
  }

  function updateBadge(el, variant) {
    if (!variant) return;

    const threshold = Number(el.dataset.inventoryThreshold) || 20;
    const variantData = getVariantData(el)[String(variant.id)];

    if (!variantData) return;

    let displayCount = variantData.metafieldCount;

    if (typeof variantData.inventoryQuantity === 'number' && variantData.inventoryQuantity < threshold) {
      displayCount = variantData.inventoryQuantity;
    }

    const shouldShow = variantData.available && displayCount !== null && displayCount !== undefined && displayCount !== '' && Number(displayCount) > 0;

    if (!shouldShow) {
      el.hidden = true;
      return;
    }

    el.hidden = false;

    const textEl = el.querySelector('[data-availability-badge-text]');

    if (textEl) {
      textEl.textContent = el.dataset.labelTemplate.replace('{count}', displayCount);
    }
  }

  function init() {
    document.addEventListener('variantChange', function (event) {
      const container = event.target;

      if (!container || typeof container.querySelectorAll !== 'function') return;

      container.querySelectorAll(selector).forEach(function (el) {
        updateBadge(el, event.detail.variant);
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}();
